import { client } from "../client";

export const NOTE_TYPES = [
  "Email",
  "Phone",
  "Letter",
  "File",
  "Note",
  "SystemNote",
] as const;
export type NoteType = typeof NOTE_TYPES[number];

export interface NoteDetails {
  id: string;
  subject: string;
  createdDttm: string;
  user: string;
  type: NoteType;
  summary: string;
  content: string;
  entries: Entry[];
}

export interface Entry {
  id: string;
  content: string;
  createdDttm: string;
  user: string;
}

export const getNoteDetails = (
  querykey: string,
  { accountNumber, noteId }: { accountNumber: string; noteId: string },
) => {
  return client
    .get<NoteDetails>(`accounts/${accountNumber}/notes/${noteId}`)
    .then((res) => res.data);
};
